import { VariantKey } from 'products/types'

export const FragilePilotPrices: Partial<Record<VariantKey, number>> = {
	full: 159,
	queen: 169,
	king: 189,
	caliking: 189,
}
